module.exports = __webpack_public_path__ + "static/media/checkout2.bed8af77.png";